import React, { FunctionComponent } from 'react';

import clsx from 'clsx';

import { SocialContact, SocialContactType } from '@domains/contacts';

import { MaxIcon, PhoneIcon, TelegramFilledRoundedIcon } from '@components/icons';

import styles from './SocialContacts.module.scss';

type ContactIconsProps = {
    contacts: SocialContact[];
    classes?: Classes<'root' | 'links' | 'link'>;
};

const contactTypeToIconMap: Record<SocialContactType, SvgIcon> = {
    [SocialContactType.Max]: MaxIcon,
    [SocialContactType.Telegram]: TelegramFilledRoundedIcon,
    [SocialContactType.Phone]: PhoneIcon,
};

const contactTypeToClassNameMap: Record<SocialContactType, string> = {
    [SocialContactType.Max]: styles.max,
    [SocialContactType.Telegram]: styles.telegram,
    [SocialContactType.Phone]: styles.phone,
};

export const SocialContacts: FunctionComponent<ContactIconsProps> = (props) => {
    const { contacts, classes } = props;
    return (
        <div className={clsx(styles.root, classes?.root)}>
            <span className={styles.caption}>Связаться с нами:</span>
            <div className={clsx(styles.links, classes?.links)}>
                {contacts.map(({ type, href, ariaLabel }) => {
                    const Icon = contactTypeToIconMap[type];
                    return (
                        <a
                            key={type}
                            href={href}
                            className={clsx(
                                styles.link,
                                contactTypeToClassNameMap[type],
                                classes?.link,
                            )}
                            aria-label={ariaLabel}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Icon className={styles.icon} />
                        </a>
                    );
                })}
            </div>
        </div>
    );
};
